module.exports = __webpack_public_path__ + "media/entities/3002-85153f5a.png";